import { render, staticRenderFns } from "./DatasetFilterButton.vue?vue&type=template&id=d4819f32&scoped=true"
import script from "./DatasetFilterButton.vue?vue&type=script&lang=js"
export * from "./DatasetFilterButton.vue?vue&type=script&lang=js"
import style0 from "./DatasetFilterButton.vue?vue&type=style&index=0&id=d4819f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4819f32",
  null
  
)

export default component.exports